import { CountUp } from "countup.js"

const ATTRIBUTE = "data-countup"
const SELECTOR = `[${ATTRIBUTE}]`

export function useCountups (document) {
  const elements = document.querySelectorAll(SELECTOR)
  const options = {
    autoAnimate: true,
    separator: ".",
    decimal: ","
  }

  elements.forEach(element => {
    new CountUp(element, element.getAttribute(ATTRIBUTE), options)
  })
}
